import AdminPanel from "./AdminPanel";
import { T } from "./theme";

/**
 * Applique la regle absolue ReturnOb : quand une donnee ou une action
 * depend d'un contrat backend qui n'existe pas (ou dont l'appel a
 * echoue), on l'affiche explicitement comme indisponible - jamais un 0,
 * jamais une simulation.
 */
export function AdminUnavailablePanel({ t, title, description }) {
  return (
    <AdminPanel>
      <strong>{title || t("admin.api_unavailable_title")}</strong>
      <p style={{ color: T.muted, marginBottom: 4 }}>{description || t("admin.integration_description")}</p>
      <small style={{ color: T.muted }}>{t("admin.no_simulated_data")}</small>
    </AdminPanel>
  );
}

export function ValueUnavailable({ t }) {
  return <span style={{ color: T.muted, fontStyle: "italic" }}>{t("admin.value_unavailable")}</span>;
}
